import UpdatePaymentSource from '@/services/payments/UpdatePaymentSource';
import UpdateBillingAddress from '@/services/payments/UpdateBillingAddress';

export default class PaymentService {
    /**
     * Handle updating a users billing address.
     *
     * @param {number} userId
     * @param {number} addressId
     * @param {*}      payload
     *
     * @return {Promise}
     */
    updateBillingAddress(userId, addressId, payload) {
        return (new UpdateBillingAddress()).handle(userId, addressId, payload);
    }

    /**
     * Handle updating the authenticated user's card details in the payment gateway.
     *
     * @param {int} userId
     * @param {string} cardToken
     * @param {string} cardId
     * @param {string} nameOnCard
     *
     * @returns {Promise}
     */
    updatePaymentSource(userId, cardToken, cardId, nameOnCard, paymentMethod) {
        return (new UpdatePaymentSource()).handle(userId, cardToken, cardId, nameOnCard, paymentMethod);
    }
}
